import { findAgreement } from 'helpers/agreements';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useAgreements from 'services/agreements/useAgreements';
import { AgreementKey } from 'types/Agreement';

export default function useAgreement(agreementKey: AgreementKey) {
  const { currentTinyAccountId, currentKitId } = useCurrentKitAndTinyAccount();
  const { data: agreements } = useAgreements();

  return findAgreement(
    agreements,
    agreementKey,
    currentTinyAccountId ?? '',
    currentKitId ?? '',
  );
}
